<template>
  <div class="el-pagination is-background flex justify-end">
    <el-button class="btn-prev" :disabled="page<2" @click="change(1)"><i class="el-icon el-icon-arrow-left"></i></el-button>
    <ul class="el-pager"><li class="number">{{ page }}</li></ul>
    <el-button class="btn-next" :disabled="page==total" @click="change(2)"><i class="el-icon el-icon-arrow-right"></i></el-button>
  </div>
</template>
  <script>
export default {
  props: ["page",'total'],
  data(){
    return {
    }
  },
  methods:{
    change(e){
        this.$emit('change',e)
    }
  }
};
</script>
      <style scoped>
  .el-icon{
    margin-top: 8px;
  }
</style>


// WEBPACK FOOTER //
// src/components/mPage.vue